const messages = {
  bonus: {
    title: "Resumen de créditos de bonus",
    description: "Los bonus en euros se conceden a las empresas participantes en función de las cifras de ventas enviadas.",
    lastMonth: "Mes pasado",
    currentMonth: "Mes actual",
    totalCurrentYear: "Total del año actual",
    totalLastYear: "Total del año pasado",
  },
  points: {
    title: "Resumen de créditos de puntos",
    period: "Año natural en curso ({year})",
    totalAwarded: "Total de puntos otorgados",
    redeemed: "Puntos canjeados",
    totalBalance: "Saldo total de puntos",
    redemptionRate: "Puntos canjeados como porcentaje de los puntos otorgados",
    averageAwarded: "Media de puntos otorgados por neumático comprado",
    standardAwarded: "Puntos netos de las líneas de venta calculadas, devoluciones incluidas",
    bsPlusInclBooster: "Puntos de las líneas de venta con cantidad positiva",
    perTire: "Puntos canjeados por neumático comprado",
  },
  tires: {
    title: "Resumen de cantidad de neumáticos",
    description: "Neumáticos comprados por los clientes",
    prevMonth: "Mes anterior",
    totalLastYear: "Total del año pasado",
    purchaseIndirect: "Compra a través de mayorista (indirecta)",
    purchaseDirect: "Compra a través de mayorista (directa)",
    totalCurrentYear: "Total del año actual",
    currentMonth: "Mes actual",
  },
  participating: {
    title: "Resumen de clientes participantes",
    description: "Las empresas que se registran en BRIDGESTONE PLUS pueden ser asignadas por nosotros mediante el número de cliente.",
    total: "Total",
    newThisMonth: "Nuevos este mes",
    newThisYear: "Nuevos este año",
    createdInCurrentMonth: "Creado en el mes actual (por administrador)",
    loginsCurrentYear: "Inicios de sesión del año actual (tras aceptar las condiciones)",
  },
  brand: {
    title: "Marca",
    description: "Tus compras en detalle",
    centerTitle: "Por\nmarca",
  },
  rim: {
    title: "Llanta",
    centerTitle: "Por tamaño\nde llanta",
  },
  tireGoals: {
    title: "Objetivos de neumáticos",
    subtitle: "Gana puntos por tus compras de neumáticos.",
    centerTitle: "Por\nmedida de neumático",
    tiresRemaining: "Neumáticos restantes",
    progressionTarget: "Objetivo de progreso: ",
    pointsEarnedPurchases: "puntos ganados\n" + "por tus\n" + "compras",
    pointsEarnedBoosters: "puntos ganados\n" + "por\n" + "boosters",
    purchasesDetail: "Tus compras en detalle",
    cta: "Más información sobre tus puntos",
    pointsTitle: "Tus puntos",
    pointsSubtitle: "Puntos ganados en tus compras Bridgestone",
    achievementsTitle: "Tus logros",
    achievementsSubtitle: "Tu compromiso anual:",
    achievementsSubtitle2: "neumáticos",
  },
  score: {
    title: "Puntuación",
    total: "Total",
    credits: "Créditos en",
    deductions: "Deducciones en",
        unlockedPoints: "Puntos desbloqueados",
        pendingPoints: "Puntos pendientes",
  },
  score_extended: {
    title1: "Saldo de puntos",
    title2: "Bonus en euros",
    balance: "Saldo de puntos",
    bonus_in_euro: "Bonus en euros",
    date: "Fecha",
    added_points: "Puntos añadidos en",
    total_bands: "Total de marcas",
    goal: "Objetivo",
    tyres_previous_year: "Neumáticos vendidos el año pasado",
    tyres_current_year: "Neumáticos vendidos este año",
    target_this_year: "Objetivo de ventas de este año",
    bonus_this_year: "Bonus ganado (€)",
    loyal_minimum: "Nivel mínimo de fidelidad",
    bonus_multiplier: "Tasa multiplicadora del bonus",
  },
  lastImport: {
    label: "Última importación de cifras de ventas:",
    on: "el",
  },
  wholesalerTable: {
    title: "Clientes participantes en detalle",
    description: "A continuación encontrarás las empresas que se han registrado en BRIDGESTONE PLUS con el número de cliente de tu empresa. Puedes utilizar los filtros para otro tipo de ordenación o la búsqueda para localizar clientes.",
    columns: {
      customer_number: "N.º cliente",
      address_company_name: "Empresa",
      address_street: "Calle y número",
      address_postal_code: "Código postal",
      address_city: "Ciudad",
      last_registration: "Último registro",
      network: "Red",
      profile_group: "Grupo",
      tires_amount: "Cantidad de neumáticos",
      point_balance: "Saldo de puntos",
      bonus: "Bonus",
      details: "Detalles",
    },
    searchPlaceholder: "Buscar",
  },
  dealerTable: {
    columns: {
      date: "Fecha",
      wholesaler_bs_plus: "Mayorista BS+",
      customer_number: "Número de cliente",
      article: "Artículo",
      brand: "Marca",
      product: "Producto",
      type: "Tipo",
      inch: "Pulgadas",
      season: "Temporada",
      amount: "Cantidad",
      points: "Puntos",
      activity: "Actividad",
      total_points: "Puntos totales",
    },
    title: "Tabla de distribuidores",
    description: "Resumen de la actividad de los distribuidores",
  },
  business_units: {
    title: "Unidades de negocio",
    centerTitle: "Por\nunidad",
  },
  season: {
    title: "Temporada",
    centerTitle: "Por época\ndel año",
  },
};

export default {
  messages,
};
